const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "invitations/SET_INVITATIONS":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          result: action.payload,
        },
      }
    case "invitations/SET_LOADING":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          loading: action.payload,
        },
      }
    case "invitations/SET_ERROR":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
